import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Plus,
  FileText,
  BarChart as BarChartIcon,
  CreditCard,
} from "lucide-react";
import { CouponsAnalytics } from "./coupons/CouponsAnalytics";
import { CouponsRules } from "./coupons/CouponsRules";
import { CouponsTransaction } from "./coupons/CouponsTransaction";
import { CouponsTransactionReport } from "./coupons/CouponsTransactionReport";

export default function Coupons() {
  const [activeTab, setActiveTab] = useState<string>("analytics");

  const couponTabs = [
    {
      id: "analytics",
      name: "Analytics",
      icon: BarChartIcon,
    },
    {
      id: "all",
      name: "Coupon Rules",
      icon: FileText,
    },
    {
      id: "transactions",
      name: "Transaction",
      icon: CreditCard,
    },
    {
      id: "transaction-report",
      name: "Transaction Report",
      icon: FileText,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Coupons</h1>
          <p className="text-muted-foreground">
            Manage and track all your coupon campaigns and promotions
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          {couponTabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id} className="text-sm">
              <tab.icon className="h-4 w-4 mr-2" />
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="analytics" className="space-y-6">
          <CouponsAnalytics />
        </TabsContent>

        <TabsContent value="all" className="space-y-6 mt-6">
          <CouponsRules />
        </TabsContent>

        <TabsContent value="transactions" className="space-y-6">
          <CouponsTransaction />
        </TabsContent>

        <TabsContent value="transaction-report" className="space-y-6 mt-6">
          <CouponsTransactionReport />
        </TabsContent>
      </Tabs>
    </div>
  );
}
